import request from "@/utils/request";

// 文件上传
export function uploadFile(data) {
  return request({
    url: "/system/public/uploadAdmin",
    method: "post",
    data
  });
}

// 本地导入
export function clientEnterprise(data) {
  return request({
    url: "/system/clientEnterprise/importClientEnterpriseLocal",
    method: "post",
    data
  });
}

// 报告上传
export function uploadAdminAndPage(data) {
  return request({
    url: "/system/public/uploadAdminAndPage",
    method: "post",
    data
  });
}

// 获取用户信息
export function getUser(data) {
  return request({
    url: "/system/User/getUser",
    method: "get",
    data
  });
}

// 发送验证码
export function getSms(data) {
  return request({
    url: "/system/Sms/getSms",
    method: "get",
    params: data
  });
}

// 修改密码
export function editPassword(data) {
  return request({
    url: "/system/User/UpdateadminPassword",
    method: "post",
    data
  });
}

// // 文件上传
// export function uploadAdmin(data) {
//   return request({
//     url: "/system/public/uploadAdmin",
//     method: "post",
//     data
//   })
// }

// 字典
export function getDicRadioButton(data) {
  return request({
    url: "/system/code/getCodeByStatus",
    method: "get",
    params: data
  });
}


// // 技术知识
// export function getKnowTechList(data) {
//   return request({
//     url: 'system/knowTech/getKnowTechList',
//     method: 'get',
//     params: data
//   })
// }

// // 行业
// export function getIndustryList(data) {
//   return request({
//     url: 'system/industry/getIndustryLists',
//     method: 'get',
//     params: data
//   })
// }

// // 领域
// export function getKnowFieldList(data) {
//   return request({
//     url: 'system/knowField/getKnowFieldList',
//     method: 'get',
//     params: data
//   })
// }

// 技术知识
export function getKnowTechList(data) {
  return request({
    url: "system/knowTech/getKnowTechLabelList",
    method: "get",
    params: data
  });
}

// 行业
export function getIndustryList(data) {
  return request({
    url: "system/industry/getIndustryLabelLists",
    method: "get",
    params: data
  });
}

// 领域
export function getKnowFieldList(data) {
  return request({
    url: "system/knowField/getKnowFieldLabelList",
    method: "get",
    params: data
  });
}

// 产品类别
export function productCategoryApi(data) {
  return request({
    url: "/system/dict/data/type/productCategory",
    method: "get",
    params: data
  });
}
//园区数据-园区类型
export function parkTypeOptionsApi(data) {
  return request({
    url: "/management/park/selectParkType",
    method: "get",
    params: { id: 1 }
  });
}
//产业机构-机构类型
export function industryTypeApi(query) {
  return request({
    url: "/system/dict/data/type/industry_type",
    method: "get",
    params: query
  });
}
// 查询城市
export function getCityAll() {
  return request({
    url: "system/city/getCityAll",
    method: "get"
  });
}

//文件上传签名
export function uploadsign() {
  return request({
    url: "system/public/sign",
    method: "get"
  });
}

// 下载单个文件
export function downloadFile() {
  return request({
    url: "system/public/downloadFile",
    method: "get"
  });
}

// 富文本上传图片
export function apiUploadStr(data) {
  return request({
    url: "/system/public/apiUploadStr",
    method: "post",
    data
  });
}

// 获取国外城市
export function getForeignArea() {
  return request({
    url: "/system/city/getForeignArea",
    method: "get"
  });
}

// 获取四级标签
export function getIndustryLabelFour(params) {
  return request({
    url: "/system/industry/getIndustryLabelFour",
    method: "get",
    params
  });
}

// 模板下载
export function downloadTemplate(params) {
  return request({
    url: "/system/clientEnterprise/downloadTemplate",
    method: "get",
    params
  });
}